<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('firmware.create')" @invoke-method="invokeMethod($event)" action="showFirmwareVersion"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetFirmwareVersions()"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="firmware_versions" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showFirmwareVersion(props.item)">
                                <td>{{ props.item.version }}</td>
                                <td>{{ props.item.battery_empty }}</td>
                                <td>{{ props.item.battery_full }}</td>
                                <td>{{ props.item.change_log }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="settings_firmware"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="firmware_version_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{
                            currObjField("firmware_version_id") ? $t("lang.edit_firmware_version") : $t("lang.add_firmware_version")
                        }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeFirmwareVersionDialog"
                            :dialog-status="firmware_version_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="firmware_version">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="firmware_version_dialog"
                                            v-model="firmware_version.version"
                                            :label="`${$t('lang.version')} *`"
                                            :counter="showCounter(firmware_version.version, 'firmware_version.version')"
                                            :rules="ifValid('firmware_version.version')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="firmware_version.battery_empty"
                                            :label="`${$t('lang.battery_empty')} *`"
                                            :counter="showCounter(firmware_version.battery_empty, 'firmware_version.battery_empty')"
                                            :rules="ifValid('firmware_version.battery_empty')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="firmware_version.battery_full"
                                            :label="`${$t('lang.battery_full')} *`"
                                            :counter="showCounter(firmware_version.battery_full, 'firmware_version.battery_full')"
                                            :rules="ifValid('firmware_version.battery_full')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="firmware_version.change_log"
                                            :label="$t('lang.change_log')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('firmware_version.change_log')"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('firmware_version_id')" color="error" @mouseup.left="$refs.delete_firmware_version.openDialog()">{{
                            $t("lang.delete")
                        }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeFirmwareVersionDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            color="success"
                            @mouseup.left="modifyFirmwareVersion(currObjField('firmware_version_id') ? 'patch' : 'post', currObjField('firmware_version_id'))"
                            >{{ $t("lang.save") }}</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_firmware_version"
                :heading="$t('lang.delete_firmware_version')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyFirmwareVersion('delete', currObjField('firmware_version_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                {
                    text: this.$t("lang.version"),
                    sortable: false,
                    width: "25%",
                },
                {
                    text: this.$t("lang.battery_empty"),
                    sortable: false,
                    width: "25%",
                },
                {
                    text: this.$t("lang.battery_full"),
                    sortable: false,
                    width: "25%",
                },
                {
                    text: this.$t("lang.change_log"),
                    sortable: false,
                    width: "25%",
                },
            ],

            firmware_version: {
                version: "",
                battery_empty: "0.00",
                battery_full: "0.00",
                change_log: "",
            },
            current_obj: null,
            filter: {
                search: "",

                page_size: 0,
                page_num: 0,
            },
            firmware_version_dialog: false,
            mobile_list: [
                {
                    title: this.$t("lang.add_new"),
                    action: "showFirmwareVersion",
                },
                {
                    title: this.$t("lang.refresh"),
                    action: "dbGetFirmwareVersions",
                },
            ],
            dbGetFirmwareVersions: _.debounce(this.getFirmwareVersions, 1500, {
                maxWait: 1500,
                leading: true,
                trailing: false,
            }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchFirmwareVersion", {
                url: "firmware",
                method: "get",
                stateProperty: "firmware_versions",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.firmware_versions) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchFirmwareVersion", {
                url: "firmware",
                method: "get",
                stateProperty: "firmware_versions",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.firmware_versions) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_firmware_version: (state) => state.validation.rules_firmware_version,
            default_filter: (state) => state.firmware_versions.firmware_versions_filter,
            page: (state) => state.firmware_versions.page,
            firmware_versions: (state) => state.firmware_versions.firmware_versions,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        closeFirmwareVersionDialog() {
            this.firmware_version_dialog = false;
            this.$refs.delete_firmware_version.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getFirmwareVersions() {
            this.startLoader();
            this.$store
                .dispatch("fetchFirmwareVersion", {
                    url: "firmware",
                    method: "get",
                    stateProperty: "firmware_versions",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.firmware_version_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },

        modifyFirmwareVersion(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("firmware_version")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchFirmwareVersion", {
                                pk: "firmware_version_id",
                                id: id,
                                url: `firmware/${id ? id : ""}`,
                                method: method,
                                stateProperty: "firmware_versions",
                                mutate: true,
                                body: this.firmware_version,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeFirmwareVersionDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showFirmwareVersion(item = null) {
            this.current_obj = item;

            if (this.$refs.firmware_version) item ? this.$refs.firmware_version.resetValidation() : this.$refs.firmware_version.reset();

            this.$nextTick(() => {
                this.assignObj(this.firmware_version, item, this.rules_firmware_version);
                this.firmware_version_dialog = true;
            });
        },
    },
};
</script>
